// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("cocoon")
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')

import $ from 'jquery'
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker'

require("bootstrap")
require("bootstrap-datepicker")

require('website/bootstrap-select.min')
require('website/popper.min')

import I18n from 'i18n-js'
window.I18n = I18n
require('i18n/translations')
require('website/i18n_locale_sync')

// Shared JS copy for alerts (en/fi from app/javascript/i18n/translations.js)
window.jsAlerts = {
  wrapWarning: function (messageHtml) {
    return (
      "<div class='alert alert-warning alert-dismissible'>" +
      messageHtml +
      "<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button></div>"
    );
  },
  t: function (key, interpolations) {
    if (typeof window.i18nTranslateWithFallbacks === 'function') {
      return window.i18nTranslateWithFallbacks("js.general.alerts." + key, interpolations || {});
    }
    if (!window.I18n || !window.I18n.t) return "";
    return window.I18n.t("js.general.alerts." + key, interpolations || {});
  }
};

$(document).on("click", "a.js-block-ad-edit-after-auction-end", function (e) {
  var raw = this.getAttribute("data-auction-end-at");
  if (!raw) return;
  var endMs = Date.parse(raw);
  if (!isFinite(endMs) || Date.now() < endMs) return;
  e.preventDefault();
  var msg =
    (window.jsAlerts && window.jsAlerts.t("ad_information_edit_blocked_auction_ended")) ||
    "Ilmoituksen muokkaus ei ole mahdollista, koska huutokaupan päättymisaika on umpeutunut.";
  alert(msg);
  return false;
});

require('website/acommon')
require('website/step1_validation')
require('website/step3_validation')
require('website/user')
require('website/jquery-ui-1.10.1.custom.min')
require('website/jquery.jscroll')
require('website/jquery.timepicker.min')
require('website/office')
require('website/filter')
require('website/service')
require('website/maps')
require('website/document_group')
require('website/ad')
require('website/invoice')
// require('website/jquery.keyboard')
require('moment')
require("packs/select2setup")
require('website/mobiscroll.jquery.min.js')
require('website/recaptcha_signup')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

require("trix")
require("@rails/actiontext")

$.fn.datepicker.dates.en = {
  days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
  daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],
  daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],
  months:["January","February","March","April","May","June","July","August","September","October","November","December"],
  monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],
  today:"Today",
  monthsTitle:"Months",
  clear:"Clear",
  weekStart:1,
  format:"dd.mm.yyyy",
  titleFormat: "dd.mm.yyyy"
}

$.fn.datepicker.dates.fi = {
  days:["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"],
  daysShort:["sun","maa","tii","kes","tor","per","lau"],
  daysMin:["su","ma","ti","ke","to","pe","la"],
  months:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],
  monthsShort:["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],
  today:"tänään",
  clear:"Tyhjennä",
  weekStart:1,
  format:"dd.mm.yyyy",
  titleFormat: "dd.mm.yyyy"
}

// Bootstrap-datepicker locales defined above are en/fi only; normalize fi-FI -> fi, unknown -> en.
window.datepickerLanguageFromHtmlLang = function () {
  var meta = typeof document !== 'undefined' && document.querySelector('meta[name="application-locale"]');
  var hint = (meta && meta.getAttribute('content')) ? meta.getAttribute('content').trim() : '';
  var fromHtml = (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang)
    ? document.documentElement.lang.trim()
    : '';
  var raw = fromHtml || hint || 'fi';
  var code = raw.split('-')[0].toLowerCase();
  if ($.fn.datepicker.dates && $.fn.datepicker.dates[code]) return code;
  if ($.fn.datepicker.dates && $.fn.datepicker.dates.fi) return 'fi';
  return 'en';
};

// Principal report needs historical report ranges; all other .datepicker inputs stay "from today".
function monetBindDatepickerCollection($fields, locale, extraOpts) {
  if (!$fields || !$fields.length) return;
  var opts = $.extend(
    {
      format: 'dd.mm.yyyy',
      autoclose: true,
      todayBtn: 'linked',
      todayHighlight: true,
      orientation: 'bottom',
      weekStart: 1,
      language: locale
    },
    extraOpts || {}
  );
  $fields.datepicker(opts).on('changeDate', function () {
    var form = $(this).closest('form');
    var isDisplayDate = $(this).hasClass('display_date');
    if (isDisplayDate) {
      setTimeout(function () {
        validateAndToggleButtons(form);
      }, 50);
      setTimeout(function () {
        validateAndToggleButtons(form);
      }, 200);
      setTimeout(function () {
        validateAndToggleButtons(form);
      }, 500);
    } else {
      setTimeout(function () {
        validateAndToggleButtons(form);
      }, 100);
    }
  });
}

function monetInitAllDatepickers(locale) {
  monetBindDatepickerCollection($('.datepicker').not('#principal-report-form .datepicker'), locale, { startDate: '0d' });
  monetBindDatepickerCollection($('#principal-report-form .datepicker'), locale, {});
}

document.addEventListener("DOMContentLoaded", function() {
  var locale = window.datepickerLanguageFromHtmlLang();
  monetInitAllDatepickers(locale);

  $("#auction_publication_date").on("change", function() {
    var form = $(this).closest('form');
    var auction_category = $("#auction_category").val();
    const publicationDateStr = $("#auction_publication_date").val();
    const auctionDateStr = $("#auction_auction_date").val();

    const auction_publication_date = publicationDateStr ? parseDate(publicationDateStr) : null;
    const auction_date = auctionDateStr ? parseDate(auctionDateStr) : null;

    // Universal date validation - check dates only if both exist
    if (auction_category == 'online_auction') {
      var isImmediate = $('#immediate_sale_ad').is(':checked');
      if (isImmediate) {
        // For immediate auctions, just clear any errors if publication_date is filled
        if (auction_publication_date) {
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#auction_publication_date_notice").html("");
        }
      } else if (auction_publication_date && auction_date) {
        // For scheduled online auctions, compare dates only
        if(auction_publication_date < auction_date) {
          $("#auction_publication_date_notice").html(window.jsAlerts.wrapWarning(window.jsAlerts.t("online_auction_publication_end_after_start")))
          $(".checkMandatory").addClass("disableattchmentbutton");
        }else{
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#auction_publication_date_notice").html("");
        }
      }
    } else if (auction_category == 'auction_notice' && typeof window.validateAuctionNoticeSchedule === 'function') {
      window.validateAuctionNoticeSchedule();
    }

    // Always re-validate form when date changes (universal)
    setTimeout(function() {
      validateAndToggleButtons(form);
      // Also trigger step3 validation if available
      if (typeof window.validateStep3 === 'function') {
        window.validateStep3();
      }
    }, 150);
    remove_validation_text(this);
  });

  $("#auction_auction_date").on("change", function() {
    var form = $(this).closest('form');
    var auction_category = $("#auction_category").val();
    const publicationDateStr = $("#auction_publication_date").val();
    const auctionDateStr = $("#auction_auction_date").val();

    const auction_publication_date = publicationDateStr ? parseDate(publicationDateStr) : null;
    const auction_date = auctionDateStr ? parseDate(auctionDateStr) : null;
    if(auction_publication_date && auction_date){
      if (auction_category == 'online_auction'){
        if(auction_publication_date < auction_date) {
          $("#scheduled_date_notice").html(window.jsAlerts.wrapWarning(window.jsAlerts.t("online_auction_publication_start_before_end")))
          $(".checkMandatory").addClass("disableattchmentbutton");
        }else{
          $(".checkMandatory").removeClass("disableattchmentbutton");
          $("#scheduled_date_notice").html("");
        }
      } else if (auction_category == 'auction_notice' && typeof window.validateAuctionNoticeSchedule === 'function') {
        window.validateAuctionNoticeSchedule();
      }
      $(form).find("button[type='submit']").prop('disabled',false);
    } else if (auction_category == 'auction_notice' && typeof window.validateAuctionNoticeSchedule === 'function') {
      window.validateAuctionNoticeSchedule();
    }
    // Always re-validate form when date changes
    setTimeout(function() {
      validateAndToggleButtons(form);
      // Also trigger step3 validation if available
      if (typeof window.validateStep3 === 'function') {
        window.validateStep3();
      }
    }, 100);
    remove_validation_text(this);
  });

  $(".ad_attachment_date").on("change", function() {
    var auction_id = $("#auction_id").val();
    var id = getId(this.id);
    var attachment_date = $("#ad_attachment_date_"+id).val();

    $.ajax({
      url: '/admin/auctions/'+ auction_id +'/update_attachments',
      type: 'GET',
      data: {id: auction_id, attachment_id: id, attachment_date: attachment_date}
    });
  });


});

// Scroll-to-top button (ARROW UP) - same behavior as front page, for Manage OWN/ANOTHER and archive
document.addEventListener('DOMContentLoaded', function() {
  var SCROLL_THRESHOLD = 200;
  function checkScrollToTopVisibility() {
    var btn = document.getElementById('scroll-to-top');
    if (!btn) return;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > SCROLL_THRESHOLD) {
      btn.classList.add('scroll-to-top--visible');
    } else {
      btn.classList.remove('scroll-to-top--visible');
    }
  }
  function scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  window.addEventListener('scroll', checkScrollToTopVisibility);
  checkScrollToTopVisibility();
  var scrollToTopBtn = document.getElementById('scroll-to-top');
  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener('click', scrollToTop);
  }
});

$(document).on('ajax:complete', function() {
  var locale = window.datepickerLanguageFromHtmlLang ? window.datepickerLanguageFromHtmlLang() : 'en';
  monetInitAllDatepickers(locale);
});

function parseDate(str) {
  // str is in DD.MM.YYYY
  const [day, month, year] = str.split(".");
  return new Date(`${year}-${month}-${day}T00:00:00`);
}

function combineAuctionScheduleDatetime(dateStr, hourVal, minuteVal) {
  if (!dateStr || (typeof dateStr === 'string' && dateStr.trim() === '')) return null;
  if (hourVal === '' || hourVal === null || hourVal === undefined || minuteVal === '' || minuteVal === null || minuteVal === undefined) return null;
  var trimmed = dateStr.trim().split('.');
  if (trimmed.length !== 3) return null;
  var d = parseDate(dateStr.trim());
  if (isNaN(d.getTime())) return null;
  var h = parseInt(hourVal, 10);
  var mi = parseInt(minuteVal, 10);
  if (isNaN(h) || isNaN(mi)) return null;
  d.setHours(h, mi, 0, 0);
  return d;
}

// Auction notice (category_type AUCTION_NOTICE): all four date/time fields + auction after publication.
window.validateAuctionNoticeSchedule = function() {
  if ($("#auction_category").val() !== 'auction_notice') return;

  $("#auction_notice_auction_date_notice").find('.js-auction-notice-schedule-alert').remove();
  $("#auction_notice_publication_date_notice").find('.js-auction-notice-schedule-alert').remove();

  function tGeneral(key, fiFallback) {
    if (typeof window.i18nTranslateWithFallbacks === 'function') {
      var m = window.i18nTranslateWithFallbacks('general.' + key, {});
      if (m && typeof m === 'string' && m.indexOf('[missing "') !== 0) return m;
    } else if (typeof window.I18n !== 'undefined' && window.I18n.t) {
      var msg = window.I18n.t('general.' + key);
      if (msg && typeof msg === 'string' && msg.indexOf('[missing "') !== 0) return msg;
    }
    return fiFallback;
  }

  var incompleteMsg = tGeneral(
    'auction_notice_schedule_incomplete',
    'Täytä huutokaupan päivä, aloitusaika, ilmoituksen julkaisupäivä ja julkaisuaika.'
  );
  var orderMsg = tGeneral(
    'auction_notice_schedule_auction_after_publication',
    'Huutokaupan päivän ja ajan tulee olla myöhäisemmät kuin ilmoituksen julkaisupäivä ja -aika.'
  );
  var alertClose = "<button type='button' class='btn-close' data-bs-dismiss='alert' aria-label='Close'></button>";

  function showScheduleAlert(containerSel, msg) {
    $(containerSel).append(
      "<div class='alert alert-warning alert-dismissible fade show js-auction-notice-schedule-alert' role='alert'>" + msg + alertClose + "</div>"
    );
  }

  // Auction (event): auction_date + start time. Publication: publication_date + post time.
  var auctionDateStr = ($("#auction_auction_date").val() || '').trim();
  var ah = $("#auction_start_time_start_hours").val();
  var am = $("#auction_start_time_start_minutes").val();
  var pubDateStr = ($("#auction_publication_date").val() || '').trim();
  var ph = $("#post_time_end_hours").val();
  var pm = $("#post_time_end_minutes").val();

  var incomplete = !auctionDateStr || !pubDateStr || ah === '' || ah === null || am === '' || am === null || ph === '' || ph === null || pm === '' || pm === null;
  if (incomplete) {
    showScheduleAlert('#auction_notice_auction_date_notice', incompleteMsg);
    return;
  }

  var auctionDt = combineAuctionScheduleDatetime(auctionDateStr, ah, am);
  var pubDt = combineAuctionScheduleDatetime(pubDateStr, ph, pm);
  if (!auctionDt || !pubDt) {
    showScheduleAlert('#auction_notice_auction_date_notice', incompleteMsg);
    return;
  }

  if (auctionDt <= pubDt) {
    showScheduleAlert('#auction_notice_publication_date_notice', orderMsg);
  }
};

function remove_validation_text(element){
  $(element).parent().closest('div').removeClass('has-error');
  $(element).parent().closest('div').find('small:eq(0)').remove();
  $(element).parent().closest('div').find('i:eq(0)').remove();
}

function getId(id){
  var idArr = id.split("_");
  return idArr[idArr.length - 1];
}
  
$(document).ready(function(){

  $(document).on('click', '#save_send_feedback_modal_form_btn', function(){
    var browser_data;
    var browser_parser = new UAParser();
    var browser_global_data = browser_parser.getResult();
    var screen_size;

    if(window){
      if(window.screen){
        screen_size = window.screen.width + 'x' + window.screen.height
      }
    }

    browser_data = {
                    'browser_name': browser_global_data.browser.name,
                    'browser_version': browser_global_data.browser.version,
                    'os_name': browser_global_data.os.name,
                    'os_version': browser_global_data.os.version,
                    'screen_size': screen_size,
                    'device_type': browser_global_data.device.type
                  }

    var data = JSON.stringify(browser_data);
    var redirection_url = window.location.href;
    $.ajax({
      url: '/send_feedback_developers_form',
      type: 'POST',
      data: {browser_data : data, current_page_url : redirection_url}
    });
  });
});